module.exports = __webpack_public_path__ + "static/safety-d5975e84f4e3837b995351ed3029b377.png";